import { Typography } from "@material-ui/core";
import React from "react";
import PaymentVariants from "../payment-variants.png";
import OrderPayForm from "./OrderPayForm";

export default function OrderInfo({
  total,
  status,
  managerName,
  managerContact,
  estimation,
  username,
  paymentId,
  goal,
  deliveryType,
  pickupPoint,
  partner,
}) {
  return (
    <div className="order-column">
      <div className="order-info">
        <div className="order-pay-info">
          <Typography
            className="order-pay-title"
            style={{
              margin: 0,
              fontSize: 16,
              fontWeight: 400,
              lineHeight: 1.13,
              marginBottom: 13,
            }}
          >
            {goal ? (
              goal
            ) : (
              <template>
                {status === "submitted" && "Итого"}
                {status === "unpaid" && "Предоплата"}
                {status === "prepaid" && "Остаток к оплате"}
              </template>
            )}
          </Typography>
          <div className="order-total-price">
            <Typography
              style={{
                margin: 0,
                fontSize: 40,
                fontWeight: 700,
                lineHeight: "0.8",
                color: "#2d2737",
                textTransform: "uppercase",
                letterSpacing: "normal",
              }}
            >
              {total}
            </Typography>
            <Typography
              style={{
                fontSize: 16,
                lineHeight: 1.25,
                fontWeight: 700,
                marginTop: "auto",
              }}
            >
              руб
            </Typography>
          </div>

          {status !== "paid" && (
            <OrderPayForm username={username} paymentId={paymentId} />
          )}

          <div className="order-payment-variants">
            <img src={PaymentVariants} />
          </div>
        </div>
        <div className="order-info-text-container">
          <div className="order-term-info">
            Планируемый срок изготовления изделий от {estimation} до{" "}
            {estimation + 3} рабочих дней с момента согласования всех деталей
            заказа, подписания чертежей и поступления денежных средств на
            расчётный счёт.
          </div>
          {deliveryType !== "no_delivery" ? (
            <div className="order-delivery-info">
              Дата и&nbsp;интервал времени оказания услуг
              по&nbsp;доставке&nbsp;/ монтажным работам согласовывается
              дополнительно после уведомления о&nbsp;готовности изделий.
            </div>
          ) : (
            <div className="order-delivery-info">
              Самовывоз: {pickupPoint ? pickupPoint : "г Москва, Дмитровское шоссе, дом 13"}.
              Ежедневно с 10:00 до 19:00.
            </div>
          )}
        </div>
      </div>
      <div className="manager-info">
        <Typography>
          {partner ? "Партнер СТЕКЛО24:" : "Ваш менеджер:"}
          <span style={{ marginLeft: 5 }}>{managerName}</span>
        </Typography>
        <Typography>{managerContact}</Typography>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/Order/OrderInfo.jsx